"use strict";

function InfoBoxDirective() {
  return {
    restrict: 'E',
    scope: {
      langKey: '@key'
    },

    link: function(scope, elem) {
      elem.addClass('info-box__wrap');
    },

    template: '<h5 class="info-box__header">' +
                '<i class="fa fa-info"></i>' +
                '{{\'publication.information\' | translate}}' +
              '</h5>' +
              '<p class="info-box__text">{{langKey | translate}}</p>'
  };
}

angular.module('dokiv')
  .directive('infoBox', InfoBoxDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/InfoBoxDirective.js
// module id = 246
// module chunks = 0